module.exports = __webpack_public_path__ + "img/icon-ignore.8ddbcce4.svg";